module.exports = __webpack_public_path__ + "img/Paladin.0de5d18a.png";